const baseURL = '/api/v1/talk-flow';
const historyBaseURL = '/api/v1/history/talk-flow';

export default {
  /**
   * @GET AI 요약 유형별 프롬프트 조회
   * */
  TALK_FLOW_SUMMARIZE_PROMPTS: `${baseURL}/summarize/prompts`,
  /**
   * @param aiPipelineId
   * @GET AI Pipeline 조회
   * */
  AI_PIPELINE_BY_ID: (aiPipelineId: string) =>
    `${baseURL}/summarize/ai-pipeline/${aiPipelineId}`,
  /**
   * @param aiPipelineId
   * @GET AI Pipeline 요약 작업 결과 조회
   * */
  AI_PIPELINE_RESULT_BY_ID: (aiPipelineId: string) =>
    `${baseURL}/summarize/ai-pipeline/${aiPipelineId}/result`,
  /**
   * @param documentId
   * @param passportId
   * @GET 개인별 AI Pipeline 요약 작업 결과 상세 조회
   * */
  AI_PIPELINE_RESULT_DETAIL: (documentId: string, passportId: string) =>
    `${baseURL}/summarize/ai-pipeline-documents/${documentId}?createdBy=${passportId}`,
  /**
   * @param documentId
   * @param aiPipelineId
   * @DELETE 개인별 AI Pipeline 요약 제거
   * */
  AI_PIPELINE_REMOVE: (documentId: string, aiPipelineId: string) =>
    `${baseURL}/summarize/ai-pipeline-documents/${documentId}/${aiPipelineId}`,
  /**
   * @POST Board v1 회의록 생성
   * */
  TALK_FLOW_DOCUMENT: `${baseURL}/document`,
  /**
   * @param documentId
   * @GET 회의록 문서 조회
   * @PUT 회의록 문서 수정
   * @DELETE 회의록 문서 삭제
   * */
  TALK_FLOW_DOCUMENT_BY_ID: (documentId: string) =>
    `${baseURL}/document/${documentId}`,
  /**
   * @param documentId
   * @POST 회의록 공통 요약본(AI 요약) 재생성 요청 (작성자 전용)
   * */
  TALK_FLOW_COMMON_SUMMARY_REGENERATE: (documentId: string) =>
    `${baseURL}/document/${documentId}/common-summary/regenerate`,
  /**
   * @param documentId
   * @POST AI 채팅 질문 송신 (비동기, 202)
   * */
  TALK_FLOW_CHAT: (documentId: string) =>
    `${baseURL}/document/${documentId}/chat`,
  /**
   * @param documentId
   * @GET AI 채팅 본인 세션 목록 (최신순)
   * */
  TALK_FLOW_CHAT_SESSIONS: (documentId: string) =>
    `${baseURL}/document/${documentId}/chat/sessions`,
  /**
   * @param documentId
   * @param sessionId
   * @GET AI 채팅 세션 메시지 이력 (최신순, 페이지)
   * */
  TALK_FLOW_CHAT_MESSAGES: (documentId: string, sessionId: string) =>
    `${baseURL}/document/${documentId}/chat/sessions/${sessionId}/messages`,
  /**
   * @GET 회의록 문서 목록 조회
   * @param createdBy 작성자 passportId, 다중 선택 시 콤마(,)로 구분해 하나의 쿼리 파라미터로 전달 (internalParticipants 와 동일 형식)
   * */
  TALK_FLOW_DOCUMENT_LIST: `${baseURL}/documents/search`,

  TALK_FLOW_RECORDING_FILE: (documentId: string) =>
    `${baseURL}/document/${documentId}/recording`,
  /**
   * @GET 최근 30일간 녹음 총 시간 조회
   * */
  TALK_FLOW_RECORDING_DURATION_LAST_30_DAYS: `${baseURL}/analysis/duration/last-30-days`,
  /**
   * @GET 최근 공유한 사람 목록 조회
   * @POST 최근 공유한 사람 목록 추가
   * */
  TALK_FLOW_SHARE_RECENT: `${historyBaseURL}/share/recent`,
  /**
   * @GET 최근 공유 대상(개인·법인·사업부·팀) 목록 페이지 조회
   * */
  TALK_FLOW_SHARE_RECENT_TARGETS: `${historyBaseURL}/share/recent-targets`,
  /**
   * @POST 단어 바꾸기 목록 추가
   * */
  TALK_FLOW_WORD_REPLACE: `${baseURL}/word-replacements/logs`,
  /**
   * @GET 단어 바꾸기 목록 조회
   * @DELETE 단어 바꾸기 목록 삭제
   * */
  TALK_FLOW_WORD_REPLACE_HISTORY: `${historyBaseURL}/word-replacement`,
};
